import { getTitleOrEmpty } from 'shared/helpers/common';

// "lte"(less than equal) - like "to"
// "gte"(greater than equal) - like "from"
export const getFromTo = ({ gte, lte }, t) => {
  if (gte && lte) return `${gte} - ${lte}`;
  else if (gte && !lte) return `${t('от')} ${gte}`;
  else if (!gte && lte) return `до ${lte}`;
  return null;
};

export const getSaveSearchParams = (props, t) => {
  if (props) {
    const {
      transport_child: transportChild,
      location,
      engine,
      gearbox,
      drive,
      category,
      currency,
      price,
      year,
      mileage,
    } = props;

    let infoList = [];
    infoList = [
      {
        title: t('Тип'),
        value: getTitleOrEmpty(transportChild),
      },
      {
        title: t('Кузов'),
        value: getTitleOrEmpty(category),
      },
      {
        title: t('двигатель'),
        value: getTitleOrEmpty(engine),
      },
      {
        title: t('Цена'),
        value: price && getFromTo(price, t),
        unitMeasurement: currency,
      },
      {
        title: t('Пробег'),
        value: mileage && getFromTo(mileage, t),
        unitMeasurement: 'тыс. км',
      },
      {
        title: t('Год'),
        value: year && getFromTo(year, t),
      },
      {
        title: t('Регион'),
        value: getTitleOrEmpty(location),
      },
      {
        title: t('Коробка'),
        value: getTitleOrEmpty(gearbox),
      },
      {
        title: t('Привод'),
        value: getTitleOrEmpty(drive),
      },
    ].filter(item => item.value);

    return infoList;
  }
};



// WEBPACK FOOTER //
// ./src/shared/helpers/searchSubscriptions.js